import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import MemberStatusListTable from '../../Model/Individual/StatisticsModel/MemberStatusListTable';
import MemberStatusBarChart from '../../Model/Individual/StatisticsModel/MemberStatusBarChart';

import IntroMarkdown from './IntroMarkdown';

export default function MemberStatusRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { intro, memberType, members, accentColor, totalRevenue, monthlyStats } = data;

  // 월별 신규/재등록/이탈 막대 차트 — 통계 MemberStatusBox 차트 재현. monthlyStats 있을 때만 렌더 //
  const hasChart = Array.isArray(monthlyStats) && monthlyStats.length > 0;

  // 신규/재등록 매출 총액 — 이탈(churned)은 매출 부적합이라 orchestrator에서 null. 값 있을 때만 카드 표시 //
  const typeLabel = memberType === 'reregistered' ? '재등록' : '신규';

  // MemberStatusBox.js 기준 accent 색상 정의 (탭별) — 다크모드 자동 정합 //
  let defaultAccentColor;
  let accentColorHover;

  if (memberType === 'reregistered') {
    defaultAccentColor = theme.webBrand500;
    accentColorHover = theme.webBrand600;
  }
  else if (memberType === 'churned') {
    defaultAccentColor = isDark ? theme.red600 : theme.red200;
    accentColorHover = isDark ? theme.red600 : theme.red200;
  }
  else {
    defaultAccentColor = theme.brand500;
    accentColorHover = theme.brand500Alpha50;
  }

  // 회원 클릭시 상세 페이지 이동 //
  function onClickMember(memberId) {
    window.open('/member/valid/detail/' + memberId, '_blank');
  }

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      {
        (totalRevenue !== null && totalRevenue !== undefined) &&
        <RevenueCard $color={theme.subBackground}>
          <RevenueLabel $color={theme.subText}>{typeLabel} 회원 매출</RevenueLabel>
          <RevenueValue $color={theme.text}>{Number(totalRevenue).toLocaleString('ko-KR')}원</RevenueValue>
        </RevenueCard>
      }
      {
        hasChart &&
        <ChartContainer $color={theme.subBackground}>
          <MemberStatusBarChart
            monthlyStats={monthlyStats}
            newColor={theme.brand500}
            renewalColor={theme.webBrand500}
            churnColor={isDark ? theme.red600 : theme.red200}
            scrollBarColor={accentColor || defaultAccentColor} />
        </ChartContainer>
      }
      <TableContainer $color={theme.subBackground}>
        <MemberStatusListTable
          members={members}
          memberType={memberType}
          accentColor={accentColor || defaultAccentColor}
          accentColorHover={accentColorHover}
          onClickMember={onClickMember} />
      </TableContainer>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 600px;
  box-sizing: border-box;

  padding: 16px 12px;

  overflow-x: auto;

  border-radius: 10px;
  background-color: ${props => props.$color};
`;

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 600px;

  overflow-x: auto;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const RevenueCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  width: 600px;
  box-sizing: border-box;

  padding: 14px 18px;

  border-radius: 10px;
  background-color: ${props => props.$color};
`;

const RevenueLabel = styled.p`
  margin: 0;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.$color};
`;

const RevenueValue = styled.p`
  margin: 0;

  font-family: NotoSansKR-Bold;
  font-size: 18px;

  color: ${props => props.$color};
`;
